import { components } from "react-select";
import Select from "react-select";
import { ReactComponent as DropdownTriangle } from 'assets/dropdown_triangle.svg';

const DropdownIndicator = (
  props: any
) => {
  return (
    <components.DropdownIndicator {...props}>
      
      <DropdownTriangle width='12' height='12'/>
    </components.DropdownIndicator>
  );
};

const SelectComponent  = ({options, placeholder, value, onChange}: {options: any, placeholder: string, value: any, onChange: any}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      components={{ DropdownIndicator }}
      styles={{
        control: (baseStyles: any) => ({
          ...baseStyles,
          border: 'none',
          borderBottom: '1px solid #F0F0F0',
          color: '#4F7D9C',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          }
        }),
        singleValue: (baseStyles: any) => ({
          ...baseStyles,
          color: '#4F7D9C',
        }),
        indicatorSeparator: () => ({
          display: 'none'
        })
      }}
    />
  )
}

export default SelectComponent;